export default __webpack_public_path__ + "static/eventImg1-df3f692f2d2be9188d33e1f910347074.svg";